(function (globalScope, factory) {
  var api = factory();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (globalScope) {
    globalScope.SavConfidenceEngineered = api;
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  function clampIndex(index, length) {
    if (!length) return 0;
    return ((index % length) + length) % length;
  }

  function initConfidenceEngineered(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ce-credential-tab]'));
    var credentialPanels = Array.prototype.slice.call(root.querySelectorAll('[data-ce-credential-panel]'));
    var engineeringTriggers = Array.prototype.slice.call(root.querySelectorAll('[data-ce-engineering-trigger]'));
    var engineeringPanels = Array.prototype.slice.call(root.querySelectorAll('[data-ce-engineering-panel]'));
    var cleanups = [];

    function selectCredential(index, shouldFocus) {
      var activeIndex = clampIndex(index, tabs.length);

      tabs.forEach(function (tab, tabIndex) {
        var active = tabIndex === activeIndex;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        if (active && shouldFocus) tab.focus();
      });

      credentialPanels.forEach(function (panel, panelIndex) {
        panel.hidden = panelIndex !== activeIndex;
      });
    }

    function selectEngineering(index) {
      var activeIndex = clampIndex(index, engineeringTriggers.length);

      engineeringTriggers.forEach(function (trigger, triggerIndex) {
        trigger.setAttribute('aria-expanded', triggerIndex === activeIndex ? 'true' : 'false');
      });

      engineeringPanels.forEach(function (panel, panelIndex) {
        panel.hidden = panelIndex !== activeIndex;
      });
    }

    tabs.forEach(function (tab, index) {
      function onClick() {
        selectCredential(index, false);
      }

      function onKeydown(event) {
        var nextIndex = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = index + 1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = index - 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        if (nextIndex === null) return;
        event.preventDefault();
        selectCredential(nextIndex, true);
      }

      tab.addEventListener('click', onClick);
      tab.addEventListener('keydown', onKeydown);
      cleanups.push(function () {
        tab.removeEventListener('click', onClick);
        tab.removeEventListener('keydown', onKeydown);
      });
    });

    engineeringTriggers.forEach(function (trigger, index) {
      function onClick() {
        selectEngineering(index);
      }

      trigger.addEventListener('click', onClick);
      cleanups.push(function () {
        trigger.removeEventListener('click', onClick);
      });
    });

    selectCredential(0, false);
    selectEngineering(0);

    return {
      selectCredential: selectCredential,
      selectEngineering: selectEngineering,
      destroy: function () {
        cleanups.forEach(function (cleanup) {
          cleanup();
        });
      },
    };
  }

  function boot(scope) {
    var context = scope || document;
    var roots = context.querySelectorAll('[data-ce-root]');

    Array.prototype.forEach.call(roots, function (root) {
      if (root.__savConfidenceEngineered) root.__savConfidenceEngineered.destroy();
      root.__savConfidenceEngineered = initConfidenceEngineered(root);
    });
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        boot(document);
      });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });
  }

  return {
    initConfidenceEngineered: initConfidenceEngineered,
    boot: boot,
  };
});

